export default (event) => {
  // eslint-disable-next-line no-undef
  if (typeof dataLayer.push === 'function') {
    // eslint-disable-next-line no-undef
    dataLayer.push({ event });
  } else {
    console.log('GTM не загружен:', `EVENT - ${event}`);
  }
};
